module.exports = __webpack_public_path__ + "assets/img/33_168.5887a270.jpg";